














import Vue from "vue";
import Component from "vue-class-component";   
import SignInForm from "@/vue/components/SignInForm.vue";

@Component({
    components: { SignInForm }
})
export default class SignInDialogue extends Vue {

    dialogVisible: boolean = false;

    show(): void {           
        this.dialogVisible = true;
    }

    hide(): void {
        this.dialogVisible = false;
    }

    onAuthenticated(): void {
        console.log("...SignInDialogue component - onAuthenticated");
        this.hide();
        // just bubble up after hiding self
        this.$emit("is-authenticated");
    }
}
